import { CSSProperties } from 'react';

const styles: CSSProperties = {
  paddingLeft: '1rem',
  marginTop: '1.5rem',
};

const FilterEmptyResult = ({ onClear }: { onClear: () => void }) => (
  <div style={styles}>
    Nothing matches your criteria.{' '}
    <button className="button-as-link" onClick={onClear}>
      Clear filter
    </button>
  </div>
);

export default FilterEmptyResult;
